// extracted by mini-css-extract-plugin
export default {"filename_title":"PagesDivider_filename_title__-lSii","divider":"PagesDivider_divider__e+OTI"};